import React from "react";
import "./About.css";
import profilePic from "../assets/profile.jpg"; // Replace with your image path

export default function About() {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-image">
          <img src={profilePic} alt="Ayomide" />
        </div>

        <div className="about-text">
          <h2>About Me</h2>
          <p>
            Hey! I’m <strong>Ayomide</strong>, a creative and detail-oriented{" "}
            <strong>Frontend Developer</strong> who’s passionate about building intuitive and
            high-performance web applications.
          </p>
          <p>
            I specialize in modern technologies like <strong>React</strong>, <strong>Tailwind CSS</strong>,
            and <strong>Firebase</strong>, and I enjoy turning great ideas into seamless digital experiences.
          </p>
          <p>
            Whether it's a responsive UI or a smooth user journey, I aim to create products that are
            visually appealing and technically sound.
          </p>
        </div>
      </div>
    </section>
  );
}
